<template>
    <div class="wos__page_index">
        <div class="container-fluid">
            <section class="wos__page-content_index">
                <div class="release" v-if="$releaseText">
                    <p class="release-text noselect">{{$releaseText}}</p>
                </div>
                <img src="/assets/images/wos__logo.svg" alt="Wellis Online System logo" width="205">
                <p class="mt-5 mb-3 ml-2" ref="mainTitle">{{$t('components.login.title')}}</p>
                <div class="row">
                    <div class="col-md-3 col-sm-12">
                        <Login v-if="!authenticated"/>
                        <AfterLoginRealmSelect v-if="authenticated && !hasRealm"/>
                    </div>
                </div>
            </section>
            <section class="wos__page-content_index ml-5">
                <LanguagePicker :guest="true" ref="langPicker"/>
            </section>
            <section class="wos__page-content_index">
                {{(new Date().getFullYear())}} &copy; Wellis Online System <br>
                <b class="font-weight-bold">UI</b>&nbsp;<small>v{{frontendVersion}}</small>
                &nbsp;|&nbsp;<b class="font-weight-bold">Server</b>&nbsp;<small>v{{serverVersion}}</small>
            </section>
        </div>
    </div>
</template>

<script>
    import Login from "../components/guest/Login";
    import LanguagePicker from "../components/common/LanguagePicker";
    import AfterLoginRealmSelect from "../components/guest/AfterLoginRealmSelect";

    export default {
        name: "GuestLayout",
        components: {AfterLoginRealmSelect, Login, LanguagePicker},

        beforeCreate() {
            if (this.$route.name === 'app.realm') {
                if (!this.$store.getters['authStore/canChangeRealm'] || this.$store.getters["authStore/hasRealm"]) {
                    return this.$router.push({name: 'app.start'});
                }

            }
        },

        computed: {
            frontendVersion() {
                return this.$app.version.frontend;
            },

            serverVersion() {
                return this.$parent.version;
            },

            authenticated() {
                return this.$store.getters['authStore/check'];
            },

            hasRealm() {
                return this.$store.getters['authStore/hasRealm'];
            }
        },

    }
</script>

<style scoped>
    .release {
        top: 0;
        left: 5%;
    }
</style>
